export enum PageName {
  YOUR_DETAILS = 'Your details',
  SCAN_DEVICE = 'Scan your device',
  ASSIGN_NAME = 'Assign a name',
  SETUP_YOUR_ACCOUNT = 'Setup your account',
  CREATE_PROFILE = 'Create profile',
}
